export const toastoptions = {
    duration: 3000,
    position: "top-right",
  };
  